import React from "react";
import { Table, Typography } from "antd";
import { useSelector } from "react-redux";

const { Title } = Typography;

const format = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

const Section4 = ({ printMode = false }) => {
  const { section4 } = useSelector((state) => state.gstr3b);

  // ✅ Convert array → map
  const backendMap = Object.fromEntries(
    (section4 || []).map((item) => [item.key, item])
  );

  const get = (key) => backendMap[key] || {};

  const data = [

    {
      key: "header_numbers",
      details: "1",
      integratedTax: "2",
      centralTax: "3",
      stateTax: "4",
      cessTax: "5",
      isHeaderRow: true,
    },

    {
      key: "sectionA",
      details: "(A) ITC Available (whether in full or part)",
      isSectionHeader: true,
    },

    {
      key: "1",
      details: "(1) Import of Goods",
      integratedTax: get("import_goods").igst ?? 0,
      centralTax: get("import_goods").cgst ?? 0,
      stateTax: get("import_goods").sgst ?? 0,
      cessTax: get("import_goods").cess ?? 0,
    },

    {
      key: "2",
      details: "(2) Import of Services",
      integratedTax: get("import_services").igst ?? 0,
      centralTax: get("import_services").cgst ?? 0,
      stateTax: get("import_services").sgst ?? 0,
      cessTax: get("import_services").cess ?? 0,
    },

    {
      key: "3",
      details:
        "(3) Inward supplies liable to reverse charge (other than 1 & 2 above)",
      integratedTax: get("reverse_charge").igst ?? 0,
      centralTax: get("reverse_charge").cgst ?? 0,
      stateTax: get("reverse_charge").sgst ?? 0,
      cessTax: get("reverse_charge").cess ?? 0,
    },

    {
      key: "4",
      details: "(4) Inward supplies from ISD",
      isISDRow: true,
    },

    {
      key: "5",
      details: "(5) All other ITC",
      integratedTax: get("all_itc").igst ?? 0,
      centralTax: get("all_itc").cgst ?? 0,
      stateTax: get("all_itc").sgst ?? 0,
      cessTax: get("all_itc").cess ?? 0,
    },
  ];

  const columns = [
    {
      title: "DETAILS",
      dataIndex: "details",
      width: "50%",
      onCell: (record) => {

        if (record.isSectionHeader) {
          return {
            colSpan: 5,
            style: {
              // fontWeight: "bold",
              // background: "#fafafa",
            },
          };
        }


        if (record.isHeaderRow) {
          return {
            style: {
              textAlign: "left",
            },
          };
        }

        return {};
      },
    },

    {
      title: "INTEGRATED TAX",
      dataIndex: "integratedTax",
      align: "right",
      render: (v, r) => {
        if (r.isSectionHeader) return null;

        if (r.isHeaderRow) return v;;

        if (r.isISDRow) return null;

        return format(v);
      },
      onCell: (r) => {
        if (r.isSectionHeader) return { colSpan: 0 };

        if (r.isHeaderRow) {
          return {
            style: {
              textAlign: "right",

            },
          };
        }

        if (r.isISDRow) return { colSpan: 0 };

        return {};
      },
    },

    {
      title: "CENTRAL TAX",
      dataIndex: "centralTax",
      align: "right",
      render: (v, r) => {
        if (r.isSectionHeader) return null;

        if (r.isHeaderRow) return v;

        if (r.isISDRow) return null;

        return format(v);
      },
      onCell: (r) => {
        if (r.isSectionHeader) return { colSpan: 0 };

        if (r.isHeaderRow) {
          return {
            style: {
              textAlign: "right",
            },
          };
        }

        if (r.isISDRow) return { colSpan: 0 };

        return {};
      },
    },

    {
      title: "STATE/UT TAX",
      dataIndex: "stateTax",
      align: "right",
      render: (v, r) => {
        if (r.isSectionHeader) return null;

        if (r.isHeaderRow) return v;

        if (r.isISDRow) return null;

        return format(v);
      },
      onCell: (r) => {
        if (r.isSectionHeader) return { colSpan: 0 };

        if (r.isHeaderRow) {
          return {
            style: {
             textAlign: "right",
            },
          };
        }

        if (r.isISDRow) return { colSpan: 0 };

        return {};
      },
    },

    {
      title: "CESS TAX",
      dataIndex: "cessTax",
      align: "right",
      render: (v, r) => {
        if (r.isSectionHeader) return null;


        if (r.isISDRow) {
          return {
            children: "--- We do not support in FORTHERP ---",
            props: {
              colSpan: 4,
              style: { textAlign: "center", color: "#666" },
            },
          };
        }

        if (r.isHeaderRow) return v;

        return format(v);
      },
      onCell: (r) => {
        if (r.isSectionHeader) return { colSpan: 0 };

        if (r.isHeaderRow) {
          return {
            style: {
              textAlign: "right",
            },
          };
        }

        if (r.isISDRow) return { colSpan: 4 };

        return {};
      },
    },
  ];

  return (
    <>
      <Title level={5}>4. Eligible ITC</Title>

      <Table
        rowKey="key"
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        scroll={printMode ? undefined : { x: "max-content" }}
      />
    </>
  );
};

export default Section4;